import {CatalogService} from './CatalogService';

export class WarehouseService extends CatalogService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = {...newObject};
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }

    async GetAllFilteredByCompanyAndDivision(searchText?: string, companyId?: string, divisionId?: string) {
        let warehouses = await this.GetAll(searchText);
        console.log("searchText", searchText)
        console.log("companyId", companyId)
        console.log("divisionId", divisionId)

        console.log("1", warehouses)

        if (companyId) {
            warehouses = warehouses.filter((warehouse: any) => warehouse.companyId === companyId)
        }
        console.log("2", warehouses)
        if (divisionId) {
            warehouses = warehouses.filter((warehouse: any) => warehouse.divisionId === companyId)
        }
        console.log("3", warehouses)
        return warehouses
    }
}
